import script from "./invalidTokenPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./invalidTokenPage.vue?vue&type=script&setup=true&lang=ts"

import "./invalidTokenPage.vue?vue&type=style&index=0&id=73552b3f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73552b3f"]])

export default __exports__